import axios from 'axios'

/**
 * @function musicPresignGet
 * @param {string} jwt - the JWT token of the user (accessed through UserContext)
 * @returns {Promise}
 */

export const musicPresignGet = (jwt) => {
  return new Promise((resolve, reject) => {
    axios
      .get(
        `${process.env.REACT_APP_BACKEND_ADMIN_URL}/admin/api/music/presign`,
        {
          headers: {
            Authorization: `Bearer ${jwt}`
          }
        }
      )
      .then((res) => resolve(res.data))
      .catch((err) => reject(err))
  })
}
